import DownloadIcon from '@mui/icons-material/Download';
import { IconButton, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';

export interface ProjectCardDownloadButtonProps {
  /** Signed URL for the rendered media file. */
  href: string;
}

/**
 * Icon link to download the rendered project video.
 */
export function ProjectCardDownloadButton({ href }: ProjectCardDownloadButtonProps) {
  const { $t } = useIntl();
  const downloadLabel = $t({
    id: 'common.download',
    defaultMessage: 'Descargar',
  });

  return (
    <Tooltip title={downloadLabel}>
      <IconButton component="a" href={href} size="small" rel="noopener noreferrer">
        <DownloadIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
